/**
 * @copyright        2017 opencart.cn - All Rights Reserved
 * @author:          Sam Chen <sam.chen@opencart.cn>
 * @created:         2017-09-05 12:11:09
 * @modified by:     Sam Chen <sam.chen@opencart.cn>
 * @modified:        2018-07-25 10:21:19
 */

$(document).ready(function() {
  $("img.lazy").unveil(10, function() {
    $(this).on('load',function() {
      this.style.opacity = 1;
    });
  });

  $(document).on('click', '.side-open', function(event) {
    $(this).next('.side-menu').fadeIn(0).children('.side-inner').addClass('active');
    if ($(this).next('.side-menu').children('.filter-attribute-buttons')){
      $(this).next('.side-menu').children('.filter-attribute-buttons').addClass('active');
    }
    $('.assist-side').hide();
  });

  // 实现筛选按钮和tab标题垂直居中效果
  if ($('.nav-bar') && $('.nav-bar').offset()){
    $('.btn-multi-filter').css('top',($('.nav-bar').offset().top + 7.5) + 'px');
  }


  $(document).on('click', '.side-menu', function(e) {
    if ( $(e.target).closest('.side-inner').length === 0 ) {
      $('.side-menu .side-inner').removeClass('active');
      if ($('.side-menu .filter-attribute-buttons')){
        $('.side-menu .filter-attribute-buttons').removeClass('active');
      }
      setTimeout("$('.side-menu').fadeOut(50)", 220);
      $('.assist-side').show();
    }
  });

  // 关闭首页弹窗
  $(document).on('click', '.home-popup .close-popup', function(event) {
    event.preventDefault();
    $(this).parents('.home-popup').remove();
  });

  // 购物车删除弹出
  $('.checkout-cart .edit').click(function(event) {
    $(this).toggleClass('active');
    $('.product-item .cart-quantity-wrapper').toggleClass('edit-remove');
  });

  jQuery(window).scroll(function(){
    if (jQuery(this).scrollTop() > 100) {
      jQuery('.assist-side').fadeIn();
    } else {
      jQuery('.assist-side').fadeOut();
    }
  });
  // scroll-to-top animate
  jQuery('.go-top').click(function(){
    jQuery("html, body").animate({ scrollTop: 0 }, 400);
      return false;
  });

  jQuery('.go-product-form').click(function(){
    jQuery("html, body").animate({ scrollTop: $('#product-form').offset().top - 50 }, 400);
    return false;
  });
  // Language
  $(document).delegate('#language a', 'click', function(e){
    e.preventDefault();
    $('#language input[name=\'code\']').attr('value', $(this).attr('href'));
    $('#language').submit();
  })

  // Currency
  $(document).delegate('#currency a', 'click', function(e){
    e.preventDefault();
    $('#currency input[name=\'code\']').attr('value', $(this).attr('href'));
    $('#currency').submit();
  })

  /* Search */
  $('#search input[name=\'search\']').parent().find('input[type="button"]').on('click', function() {
    url = $('base').attr('href') + window.HttpServer + '?route=product/search';
    var value = $('#search input[name=\'search\']').val();
    gioEvarAction.searchEvar(encodeURIComponent(value));
    if (value) {
      url += '&search=' + encodeURIComponent(value);
    }
    // gio 搜索埋码 这里去掉， 在搜索结果页埋
    // gio('track', 'eshop_searchSuccess', {
    //   eshop_searchwords: encodeURIComponent(value),
    // });
    //预置搜索词
    var presetWord = $("#search input").attr('placeholder');
    if(value === presetWord){
      location = url + '&ishot=4';
    }else{
      location = url;
    }
  });

  // Append * to required form input
  $('.form-group').each(function () {
    if ($(this).hasClass('required')) {
      $(this).find('input').attr('placeholder', function(i, val) {
        return val + '*';
      });
    }
  });
});
